import { useInstance } from '../support/ioc/useInstance';
import { IonItem, IonLabel, IonText } from '@ionic/react';
import { UmbrellaIcon } from '../components/icons/Icons.tsx';
import { SkywatchService } from './SkywatchService.ts';

export const InsuranceButton: React.FC = () => {

    const skywatch = useInstance(SkywatchService);

    const onClick = () => {
        skywatch.getQuote({ trackingFrom: 'mission detail' });
    };

    return (
        <IonItem button detail={false} onClick={onClick}>
            <IonLabel>
                <h2>Insurance</h2>
                <p>
                    <span style={{display: 'flex', alignItems: 'center', gap: 10}}>
                        <span style={{display: 'flex', alignItems: 'center', gap: 5}}>
                            <UmbrellaIcon color="primary" size="small" />
                            <span>Get a Quote</span>
                        </span>
                    </span>
                </p>
            </IonLabel>
            <div slot="end">
                <IonText slot="end" color="primary">Free Quote</IonText>
            </div>
        </IonItem>
    );
};
